import React from 'react';

const toggler = (state: boolean) => !state;
export function useToggle(defaultValue: boolean = false) {
    const [state, toggle] = React.useReducer(toggler, defaultValue);

    return [state, toggle] as const;
}
